

















































































































import {
	AccountTypeEnum,
	PartyModel, PartyPrintModel, PartyPrintTypeEnum,
	QueryOperator,
	SortOrder,
	TenantModel,
	TenantUserModel,
	WorkTaskRuleModel
} from '@/libs/Api';
import {CrudAction, CrudReponse} from '@/libs/core/+state/models/crud-action';
import {CrudGetter} from '@/libs/core/+state/models/crud-getter';
import {createCrudQueryPayload} from '@/libs/core/+state/models/crud-query-payload';
import Page from '@/Page.vue';
import {Component, Prop, Ref, Watch} from 'vue-property-decorator';
import {workTaskRulesStore} from '@/libs/work-task-rules/+state/store';
import WorkTaskRuleCreateDialog from '../components/WorkTaskRuleCreateDialog.vue';
import WorkTaskRuleDialog from '../components/WorkTaskRuleDialog.vue';
import {partiesStore} from '../+state/store';
import {authStore} from "@/libs/auth/+store/store";
import {AuthGetter} from "@/libs/auth/models/auth-state";
import {tenantsStore} from "@/libs/tenants/+state/store";
import {CrudOrderBy} from "@/libs/core/+state/models/crud-order-by";
import ApiService from "@/libs/core/api-service";
import {b64toBlob} from "@/libs/common/functions/b64toBlob";

@Component({
    components: {
        WorkTaskRuleCreateDialog,
        WorkTaskRuleDialog
    }
})
export default class WorkTaskRules extends Page {

    stateFilter: string | null = null;
	exporting = false;
	printing = false;

    @Prop() tenantId!: string;
    @Prop() partyId!: string;

    get headers() {
        return [
            { text: "Datum vytvoření", value: "createdAt", align: "left", width: "10%" },
            { text: "Úkon", value: "catalogueItem.name", align: "left" },
            { text: "Stav", value: "workTaskState.position", align: "left", width: "10%" },
            { text: "Zahájení", value: "startDate", align: "left", width: "10%" },
            { text: "Ukončení", value: "endDate", align: "left", width: "10%" },
            { text: "Pravidelnost", value: "frequency", align: "left", width: "10%" },
            { text: "", value: "id", align: "left", sortable: false, width: "10%" }
        ];
    }

    get loading(): boolean {
        return workTaskRulesStore.useGetter(CrudGetter.Pending);
    }

    get party(): PartyModel {
        return partiesStore.useGetter(CrudGetter.Detail);
    }

    get items(): WorkTaskRuleModel[] {
        return [...workTaskRulesStore.useGetter(CrudGetter.Data)];
    }

	get enableWorkTaskRuleCreate (): boolean {
		const tenantUser = authStore.useGetter(AuthGetter.GetTenantUser) as TenantUserModel;
		const tenant = tenantsStore.useGetter(CrudGetter.Detail, this.tenantId) as TenantModel;
		return tenantUser.accountType == AccountTypeEnum.Admin || tenantUser.accountType == AccountTypeEnum.Manager || (tenantUser.accountType == AccountTypeEnum.Worker && tenant.enableCreateWorkTaskRuleByWorker == true);
	}

	@Ref() dialog!: WorkTaskRuleCreateDialog;
    @Ref() workTaskRuleDialog!: WorkTaskRuleDialog;
    @Ref() exportDialog!: any;

    @Watch("filterActive")
    filtersChanged() {
        this.loadItems();
    }

    mounted () {
        this.loadItems();
    }

    loadItems () {
        let filters = [
            { field: "partyId", op: "eq", comparand: this.partyId }
        ];
        workTaskRulesStore.dispatch(CrudAction.GetAll, createCrudQueryPayload<WorkTaskRuleModel>([
        ], filters));
    }

    reloadItems() {
        this.loadItems();
        this.dialog.loadWorkTasks();
    }

    createItemClick () {
        this.dialog.open();
    }

    createWorkTaskRuleClick (id: string) {
        this.workTaskRuleDialog.create(id, this.partyId);
    }

    openItemClick (v: WorkTaskRuleModel) {
        this.workTaskRuleDialog.open(v.id!, v.partyId!);
    }

    exportClick () {
		const party = partiesStore.useGetter(CrudGetter.Detail) as PartyModel;
		this.exporting = true;
		ApiService.api.exportWorkTaskRuleBatch(1, 99999, {
			orderby: [
				{
					field: "catalogueItem.name",
					index: 1,
					order: SortOrder.Asc
				}
			],
			predicates: [
				{ field: "partyId", op: QueryOperator.Eq, comparand: this.partyId }
			]
		}, {
			headers: {
				FileName: encodeURIComponent(`Úkony klienta ${party.displayName}`)
			}
		}).then((x: any) => {
			this.exporting = false;
			const res = x.data;
			const blob = b64toBlob(res.returnValue.base64, res.returnValue.contentType);
			const link = document.createElement('a');
			link.href = window.URL.createObjectURL(blob);
			link.setAttribute('download', res.returnValue.filename!);
			document.body.appendChild(link);
			link.click();
			link.parentNode!.removeChild(link);
		}).catch(e => {
			console.error(e);
			this.exporting = false;
		});
    }

	printClick(): void {
		this.printing = true;
		const printModel = {
			printType: PartyPrintTypeEnum.WorkTaskRules
		} as PartyPrintModel;
		ApiService.api.printParty(this.partyId, printModel).then((x: any) => {
			this.printing = false;
			const res = x.data;
			const blob = b64toBlob(res.returnValue.base64, res.returnValue.contentType);
			const link = document.createElement('a');
			link.href = window.URL.createObjectURL(blob);
			link.setAttribute('download', res.returnValue.filename!);
			document.body.appendChild(link);
			link.click();
			link.parentNode!.removeChild(link);
		}).catch(() => {
			this.printing = false;
		});
	}

}
